module.exports = __webpack_public_path__ + "img/erweima.448a0eea.png";